import { Autocomplete, Chip, List, TextField } from '@mui/material'
import { PopperWithPlacement } from '@planning/components'
import { ImdgCodes } from '@planning/constants'
import { DangerousGoodOptionListItem } from '@planning/pages/DeliveryOrders/Components/DangerousGoodsOptionListItem'
import { useTranslate } from '@tolgee/react'
import { FieldStore } from '@tom-ui/utils'
import { Observer, observer } from 'mobx-react-lite'

export const DangerousGoodsAutocomplete = observer(
  ({ fieldStore, required }: { fieldStore: FieldStore<string[]>; required?: boolean }) => {
    const { t } = useTranslate()

    const removeImdgCode = (imdg: string) => {
      fieldStore.setValue(fieldStore.value.filter(imo => imo !== imdg))
    }

    return (
      <Autocomplete
        multiple
        disableCloseOnSelect
        fullWidth
        ListboxComponent={List}
        options={ImdgCodes}
        getOptionLabel={code => code}
        PopperComponent={PopperWithPlacement}
        slotProps={{
          popper: {
            sx: { minWidth: '16rem' },
          },
        }}
        renderOption={(props, code) => (
          <DangerousGoodOptionListItem
            code={code}
            assignedCodes={fieldStore.value}
            props={props}
            key={`codes-list-option-${code}`}
          />
        )}
        value={fieldStore.value}
        renderTags={value => (
          <>
            {value
              .sort((a, b) => a.localeCompare(b))
              .map(imdg => (
                <Chip
                  key={`imo-class-option-chip-${imdg}`}
                  label={imdg}
                  onDelete={() => removeImdgCode(imdg)}
                />
              ))}
          </>
        )}
        onChange={(_, assignedCodes) => {
          fieldStore.setValue(assignedCodes)
        }}
        renderInput={params => (
          <Observer>
            {() => (
              <TextField
                required={required}
                {...params}
                sx={{ marginTop: '1rem' }}
                label={`${t('imoClass', 'IMO Class')}`}
                error={!!fieldStore.error}
                helperText={fieldStore.error ? t('fieldIsRequired', 'Field is required.') : ''}
              />
            )}
          </Observer>
        )}
      />
    )
  },
)
